<script lang="ts" setup>
  import type { PlayerSession } from '../../../shared/api/player.ts';
  import { Button } from '../../../shared/ui/button';

  defineProps<{ session: PlayerSession; hint?: string }>();
  defineEmits<{ rejoin: [] }>();
</script>

<template>
  <section class="rejoin-game-card">
    <p class="session">
      You are currently in game <strong>{{ session.gameCode }}</strong> as
      <strong class="nickname">{{ session.nickname }}</strong>
    </p>
    <Button class="rejoin-button" @click="$emit('rejoin')">Rejoin game</Button>
    <p v-if="hint" class="hint">{{ hint }}</p>
  </section>
</template>

<style scoped>
  .rejoin-game-card {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: center;
    max-width: var(--control-max-width);
    width: 100%;
  }

  .session {
    font-size: var(--font-size-md);
    margin: 0;
    overflow-wrap: anywhere;
    text-align: center;
  }

  strong {
    color: var(--color-primary);
  }

  .nickname {
    white-space: nowrap;
  }

  .rejoin-button {
    font-size: var(--font-size-md);
    min-height: var(--size-touch-target);
    padding: 0.5rem 1.5rem;
  }

  .hint {
    color: var(--color-text-muted);
    font-size: var(--font-size-xs);
    line-height: 1.4;
    margin: 0;
    text-align: center;
  }
</style>
